import { Modal, Space, Button } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons'
import { orange } from '@ant-design/colors'
import { Route, RoutingType } from '../routingApi'
import { useSaveRouteActiveMutation } from '../routingQueries'

export type RouteConflict = {
  crewMemberName: string
  day: string
  conflictDescription: string
}

export type Props = {
  visible: boolean
  onCancel: () => void
  route: Route | null
  conflicts?: RouteConflict[]
  onSuccess?: () => void
}

const ActivateRouteModal = ({ visible, onCancel, route, onSuccess }: Props) => {
  const saveRouteActiveMutation = useSaveRouteActiveMutation()

  const handleActivate = () => {
    if (route) {
      saveRouteActiveMutation.mutate({ routeId: route.id, active: true }, {
        onSuccess: () => {
          onSuccess?.()
          onCancel()
        }
      })
    }
  }

  if (!route) {
    return null
  }

  return (
    <Modal
      open={visible}
      title={
        <Space>
          <FontAwesomeIcon icon={faExclamationCircle} color={orange.primary} />
          <span>Activate Route?</span>
        </Space>
      }
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={saveRouteActiveMutation.isLoading}>
          Cancel
        </Button>,
        <Button key="activate" type="primary" onClick={handleActivate} loading={saveRouteActiveMutation.isLoading}>
          Activate
        </Button>
      ]}
      closable={true}
      maskClosable={false}
      width={500}
    >
      <div>
        <p>
          Are you sure you want to make <strong>{route.name}</strong> active? {route.routeType === RoutingType.Planned ? 'This action will create future calendar events.' : ''}
        </p>
      </div>
    </Modal>
  )
}

export default ActivateRouteModal 